export function getFirstAndLastName(name) {
    let names = name.split(" ");
    return {
      firstName: names[0],
      lastName: names[names.length - 1]
    };
  }



